import { CheckCircle, XCircle, Clock, Archive } from 'lucide-react';

export const ACTIVITY_STATUS = [
  { value: 'active', label: 'Actif', color: 'green', icon: CheckCircle },
  { value: 'inactive', label: 'Inactif', color: 'gray', icon: XCircle },
  { value: 'pending', label: 'En attente', color: 'amber', icon: Clock },
  { value: 'archived', label: 'Archivé', color: 'slate', icon: Archive },
];

export const STATUS_BADGE_COLORS = {
  green: 'bg-green-700 text-white border-green-800',
  gray: 'bg-gray-700 text-white border-gray-800',
  amber: 'bg-amber-700 text-white border-amber-800',
  slate: 'bg-slate-700 text-white border-slate-800',
};
